export const ELEMENT_WIDTH = 200;
export const UYO_STICKER_UPLOAD_PREFIX = 'uyo_sticker_';
